module.exports = __webpack_public_path__ + "static/media/slide-5.adfe3a18.jpg";